import { styled } from "@mui/material/styles";

import { accessibleInteractiveColors } from "@/theme/accessibility";

export const schedulerDrawerSx = {
  "& .MuiDrawer-paper": {
    width: { xs: "100vw", sm: "557px" },
    maxWidth: "100vw",
    boxSizing: "border-box",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
} as const;

export const schedulerDrawerContentSx = {
  width: "100%",
  maxWidth: "100vw",
  minWidth: 0,
  boxSizing: "border-box",
} as const;

export const schedulerDrawerTabsSx = {
  display: "flex",
  background: "var(--background, #F9FCFF)",
  overflowX: "auto",
  minWidth: 0,
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
} as const;

export const DrawerStyled = styled("div")(() => ({
  "& .Tabs": {
    margin: "10px",
  },
  "& .visitStatus": {
    background: "rgba(19, 232, 0, 0.09)",
    color: accessibleInteractiveColors.successTextOnTint,
    fontSize: "12px",
    fontWeight: "500",
    height: "38px",
    alignItems: "center",
    width: "100px",
    margin: "0px 10px",
    display: "grid",
    placeItems: "center",
    borderRadius: "0.2rem",
  },
  "& .Detail": {
    backgroundColor: "#EAF6FF",
    borderRadius: "10px",
    padding: " 12px",
    margin: "10px",
    width: "calc(100% - 20px)",
    minWidth: 0,
    boxSizing: "border-box",
  },
  "& .TemporarilyDate": {
    display: "flex",
    justifyContent: "space-between",
    width: "200px",
    padding: " 12px",
  },
  "& .startingDate span": {
    display: "block",
  },
  "& .EndDate span": {
    display: "block",
  },
  "& .dataAppend": {
    border: "1px solid #ccc",
    width: "300px",
    maxWidth: "calc(100% - 20px)",
    boxSizing: "border-box",
    margin: "10px",
    borderRadius: "10px",
  },
  "& .dateTime": {
    fontSize: "12px",
    fontWeight: "400",
    color: "#1F4970",
  },
  "& .stock": {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1F4970",
  },
  "& .port": {
    border: "1px solid #ccc",
    padding: "5px",
    margin: "8px",
    borderRadius: "5px",
    textTransform: "capitalize",
  },
  "& .Edit svg": {
    margin: "0px 3px",
    cursor: "pointer",
  },
  "& .planDetail": {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  },
  "& .care-team-summary": {
    minWidth: 0,
  },
  "& .care-team-summary-copy": {
    flex: "1 1 auto",
    minWidth: 0,
  },
  "& .care-team-summary-line": {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
  },
  "& .plan": {
    color: "#00261C",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    whiteSpace: "nowrap",
    // width: "386px",
    overflow: " hidden",
    textOverflow: "ellipsis",
  },
  "& .edit": {
    background: "rgba(19, 232, 0, 0.09)",
    color: accessibleInteractiveColors.successTextOnTint,
    textAlign: "center",
    fontSize: "12pX",
    fontWeight: "500",
    height: "36px",
    width: "70px",
    // margin: "10px",
  },
  "& .delete": {
    background: "#FF0000",
    color: "#ffffff",
    textAlign: "center",
    fontSize: "12pX",
    fontWeight: "500",
    height: "36px",
    width: "70px",
    // margin: "10px",
  },

  "& .cancel": {
    background: "#B1302E17",
    color: accessibleInteractiveColors.dangerTextOnTint,
    textAlign: "center",
    fontSize: "12pX",
    fontWeight: "500",
    height: "36px",
    width: "70px",
    // margin: "10px",
  },

  "& .Timer": {
    color: accessibleInteractiveColors.navigationBlue,
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    width: "100%",
    maxWidth: "480px",
    minWidth: 0,
    display: "flex",
    gap: "5px",
    margin: "5px 0px",
    wordBreak: "break-word",
  },
  "& .timer": {
    color: accessibleInteractiveColors.navigationBlue,
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    // width: "480px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    margin: "5px 0px",
    wordBreak: "break-word",
  },
  "& .userName": {
    margin: "0px",
  },
  "& .planned": {
    // width: "413px",
  },
  "& .drawer-care-team-action": {
    minWidth: "0 !important",
    minHeight: "36px !important",
    height: "36px !important",
    padding: "6px 12px !important",
    alignItems: "center",
    border: "1px solid #8FB6D9",
    borderRadius: "6px",
    background: "#DCEEFF",
    color: "#294C70",
    fontSize: "12px",
    fontWeight: "600",
    margin: "0 !important",
  },
  "& .required": {
    fontSize: "12px",
    fontWeight: "400",
    color: "#989696",
    display: "flex",
    alignItems: "center",
    margin: "3px 10px",
  },
  "& .staffTeam": {
    display: "flex",
  },
  "& .main": {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 9px",
  },
  "& .assign": {
    color: "#000",
    margin: "0px 5px",
    fontSize: "18px",
    fontWeight: "500",
  },
  "& .serve": {
    color: accessibleInteractiveColors.navigationBlue,
    fontSize: " 12px",
    fontWeight: "700",
    lineHeight: "20px",
    margin: " 0px 5px",
  },
  "& .about": {
    display: "flex",
  },
  "& .Visit": {
    color: " #000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "500",
    margin: "5px 0px",
    display: "flex",
  },
  "& .detail": {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "19.36px",
    color: "var(--tex, #989696)",
    margin: "5px",
    fontFamily: "Poppins",
    overflowX: "hidden",
    textOverflow: "ellipsis",
    // width: "65%",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  "& .user-detail": {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "19.36px",
    color: "rgb(62, 115, 164)",
    margin: "5px",
    // whiteSpace: "nowrap",
    // overflowX: "hidden",
    // textOverflow: " ellipsis",
    width: "324px",
    fontFamily: "Poppins",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  "& .plus": {
    position: "relative",
    top: "-41px",
    left: "9px",
    background: "#fff",
    boxShadow: "0px 0px 7px #ccc",
    width: "25px",
    height: "25px",
    padding: "12px",
    borderRadius: "33px",
    margin: "0px 23px 0px 0px",
    fontFamily: "poppins",
  },
  "& .teamAdd": {
    padding: "12px",
    width: "auto !important",
  },
  "& .user-Status ": {
    display: " flex",
  },
  "& .Tabs ": {
    cursor: " pointer",
    fontSize: "12px",
  },
  "& .links": {
    color: accessibleInteractiveColors.navigationBlue,
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
    width: "auto",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  "& .task ": {
    display: "flex",
    width: "10%",
    // margin: "10px",
  },
  "& .task-counter": {
    position: "relative",
    width: "45px",
    aspectRatio: "1/1",
    top: "-45px",
    left: "11px",
    backgroundColor: "#1f4970",
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    color: "white",
    fontSize: "12px",
  },
  "& .detail p": {
    margin: "0",
  },
  "& .daily-note-icon-stack": {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  "& .daily-note-card-row": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "8px",
    width: "100%",
    minWidth: 0,
  },
  "& .daily-note-card-main": {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    flex: "1 1 auto",
    minWidth: 0,
    flexWrap: "nowrap",
  },
  "& .daily-note-task-icons": {
    display: "flex",
    alignItems: "flex-start",
    width: "86px",
    flex: "0 0 86px",
    flexWrap: "nowrap",
  },
  "& .daily-note-card-copy": {
    flex: "1 1 auto",
    minWidth: 0,
  },
  "& .daily-note-card-actions": {
    flex: "0 0 auto",
  },
  "& .daily-note-card-copy .visit, & .daily-note-card-copy .detail, & .daily-note-card-copy .user-detail":
    {
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      wordBreak: "break-word",
      overflowWrap: "break-word",
    },
  "& .daily-notes, & .daily-note-1, & .daily-note-2": {
    background: "#fff",
    boxShadow: "0px 0px 7px #ccc",
    width: "47px",
    height: "47px",
    padding: 0,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    boxSizing: "border-box",
    overflow: "hidden",
    flex: "0 0 47px",
  },
  "& .daily-notes img, & .daily-note-1 img, & .daily-note-2 img": {
    display: "block",
    width: "25px",
    height: "25px",
    objectFit: "contain",
  },
  "& .daily-note-1": {
    position: "relative",
    zIndex: 2,
  },
  "& .daily-note-2": {
    position: "relative",
    top: "auto",
    right: "auto",
    zIndex: 1,
    marginLeft: "-8px",
  },
  "& .username": {
    fontWeight: "500",
    fontSize: "11px",
    lineHeight: "13.31px!important",
    color: "#989696",
    margin: "5px",
    fontFamily: "Poppins",
  },
  "& .visit": {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "19.36px",
    color: "#000000",
    margin: "5px",
    fontFamily: "Poppins",
    width: "311px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  "& p.user-detail p ": {
    margin: "0",
    // whiteSpace: "nowrap",
    overflowX: "hidden",
    // textOverflow: "ellipsis",
    // width: "60ch",
  },
  "& p.user-detail p span": {
    margin: "0",
    // whiteSpace: "nowrap",
    // overflowX: "hidden",
    // textOverflow: "ellipsis",
    width: "258px",
    display: " block!important",
  },
  "& .medication-user-Detail": {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#EAF6FF",
    borderRadius: "10px",
    padding: " 12px",
    margin: "10px",
  },
  "& .time": {
    fontSize: "12px",
    fontWeight: "500",
    color: "#651F70",
    textTransform: "capitalize",
  },
  "& .medication-user": {
    fontSize: "14px",
    fontWeight: "500",
    color: "#000000",
  },
  // "& .addMember": {
  //   // background: "rgba(0, 222, 163, 0.2);",
  //   // width: "96%!important",
  //   // color: "#00261C",
  //   // fontWeight: "500",
  //   // fontSize: "16px",
  //   // margin: "10px",
  //   // position: "relative",
  //   // justifyContent: "space-between",
  //   // fontFamily: "Poppins",
  //   "&:hover": {
  //     background: "rgba(0, 222, 163, 0.2);",
  //   },
  // },
  "& .newActivityBtn": {
    background: "#00DEA3",
    color: "#00261C",
    fontWeight: "500",
    fontSize: "16px",
    margin: "10px",
    padding: "10px",
    borderRadius: "8px",
    "&:hover": {
      background: "#00DEA3",
    },
  },
  "& .pending": {
    color: accessibleInteractiveColors.statusPending,
    fontSize: "12px",
    fontWeight: "500",
  },
  "& .status": {
    border: "1px solid rgb(204, 204, 204)",
    borderRadius: "25px",
    padding: "5px 10px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "500",
    display: "inline-flex",
    width: "74px",
    textTransform: " capitalize",
    "&.complete": {
      color: accessibleInteractiveColors.statusComplete,
      width: "92px",
      margin: "-10px",
    },
    "&.overdue": {
      color: accessibleInteractiveColors.statusOverdue,
    },
    "&.pending": {
      color: accessibleInteractiveColors.statusPending,
    },
    "&.skipped": {
      color: "#651F70",
    },
  },
  "& .secure-data-layout": {
    display: "flex",
  },
  "& .secure": {
    marginLeft: "12px",
  },
}));
